import { render, staticRenderFns } from "./EconomyBalanceInsight.vue?vue&type=template&id=4806c35e&scoped=true"
import script from "./EconomyBalanceInsight.vue?vue&type=script&lang=js"
export * from "./EconomyBalanceInsight.vue?vue&type=script&lang=js"
import style0 from "./EconomyBalanceInsight.vue?vue&type=style&index=0&id=4806c35e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4806c35e",
  null
  
)

export default component.exports